import React, { useState, useEffect } from "react";
import Md5 from 'crypto-js/md5'
import {
    ToActivateTitle, CardContainer, CardsContainer, TitlePersonalData, SubtitlePersonalData,
    FormContainer, AccordionContainer, ToActivateSubTitle,
} from "./style";
import { Card } from "../../components/Card";
import { ENV_VARIABLES } from '../../envVariables';
import { TextInput } from "../../components/TextInput";
import { ReactComponent as Iban } from "../../static/images/iban.svg";
import { ReactComponent as Invoice } from "../../static/images/invoice.svg";
import { LineSeparator } from "../../components/separators";
import { THEME_COLORS, MEDIA_QUERIES } from "../../styles/theme";
import { Offer } from "../../components/Offer";
import { BottomSheet } from "../../components/BottomSheet";
import { Accordion } from "../../components/Accordion";
import LogoRow from "../../components/LogoRow";
import ProgressionRow from '../../components/ProgressionRow';
import { TextInputHelperText } from "../../components/TextInput/TextInputHelperText";
import { CFPopup } from "./CFPopup";
import { BottomsheetTriggerContainer, BottomsheetTriggerTitle, BottomsheetTriggerSubTitle, BottomSheetHeaderText } from "../../components/BottomSheet/style";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "../../reducers/personalDataForm";
import { SubmitButton } from "../../components/Buttons";
import { VALIDATORS_TYPE, ERROR_TEXTS } from "../../utils/constants";
import { fieldValidator } from "../../utils/fieldValidator";
import { PrivacyBlock } from "../../components/PrivacyBlock";
import { ChatCallContainer } from "../../components/ChatCallContainer";
import { setTrackerScript } from "../../tracking/setTracker";
import { getTrackingInfoOffer } from "../../tracking/getTrackingInfoOffer";
import { adfSendEvent } from "../../tracking/adfSendEvent";
import { InputWrapper } from "../../components/FormContainer/components";
import OfferBox from "../../components/OfferBox";
import  { DataLayerContainerPersonalData } from "../../components/DataLayer";

export const PersonalDataPage = (props) => {
    const { offer } = props;

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    //console.log(ENV_VARIABLES.ProductAklamioArray)
    const ProductAklamioArray = ENV_VARIABLES.ProductAklamioArray
    let ChatVisible = true

    if (offer.name.includes('VIVIpartner')  || ProductAklamioArray.includes(offer.offerId) )
    {
        ChatVisible = false
    }

    useEffect(() => {
        props.onChangeText(
            PERSONAL_DATA_FORM_FIELDS_NAMES.timeStart, parseInt(Date.now() / 1000, 10)
        );
    }, []);

    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|dati-personali' });
        }
    }, [offer]);

    const closePopup = () => {
        setIsPopupOpen(false);
    }

    return (
        <React.Fragment>
            <DataLayerContainerPersonalData {...props} />
            <CFPopup
                isOpened={isPopupOpen}
                closePopup={closePopup}
                {...props.form.fiscalCodePopup}
                onChangeText={props.onChangeTextPopup}
                onChangeGender={props.onChangeGender}
                callback={props.calculateFiscalCode}
            />

            <div className="container" style={{ marginBottom: '200px' }}>

                <ChatCallContainer
                    trackerChat={() => adfSendEvent('vivigas|x|funnel|dati-personali|click_chat')()}
                    trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|dati-personali|click_ti_chiamiamo_noi")()}
                    callMeSubmitStartTrackName='vivigas|x|funnel|dati-personali|click_conferma'
                    callMeSubmitSuccessTrackName="vivigas|x|funnel|dati-personali|thankyou_richiamami"
                    isCallMeVisible={ChatVisible}
                />

                <LogoRow />

                <ProgressionRow backpath="/" step={0} />

                <div className="row">
                    <div className="col col-xl-8">
                        {!props.offer.name.includes('VIVIpartner')&& (
                        <ToActivateTitle>Offerta limitata web &nbsp;
                        <ToActivateSubTitle>- per passaggi da altro operatore.<br/>Per attivare l'offerta, tieni a portata di mano questi documenti:</ToActivateSubTitle>
                        </ToActivateTitle>
                        )}
                        {props.offer.name.includes('VIVIpartner')&& (
                            <ToActivateTitle style={{fontSize: '20px'}}>Offerta riservata ai partner di Vivigas energia
                                <ToActivateSubTitle >&nbsp;- per passaggi da altro operatore.<br/>Per attivare l'offerta, tieni a portata di mano questi documenti:</ToActivateSubTitle>
                            </ToActivateTitle>
                        )}
                        <CardsContainer>
                            <CardContainer>
                                <Card title="UNA BOLLETTA RECENTE <br/> (del tuo ex fornitore di luce e/o gas)" subtitle="Ti chiederemo alcuni dati che sono presenti in bolletta utili a completare la richiesta.
" image={Invoice} />
                            </CardContainer>
                            <CardContainer>
                                {!props.offer.name.includes('VIVIpartner')&& (
                                <Card title="IBAN" subtitle="Per addebito diretto su conto concorrente <br/> (<strong>Attenzione:</strong>  l’offerta VIVIWeb è sottoscrivibile SOLO con ADDEBITO su C/C).
" image={Iban} />)}
                                {props.offer.name.includes('VIVIpartner')&& (
                                    <Card title="IBAN" subtitle="Per addebito diretto su conto concorrente <br/>.
" image={Iban} />)}
                            </CardContainer>
                        </CardsContainer>

                        <TitlePersonalData>DATI PERSONALI</TitlePersonalData>
                        <LineSeparator />
                        <SubtitlePersonalData>Inserisci i tuoi dati per l’intestazione della fornitura (li trovi nella tua ultima bolletta).</SubtitlePersonalData>

                        <FormContainer onSubmit={e => {
                            e.preventDefault();
                        }}>
                            <InputWrapper hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Nome*"
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.name]}
                                    onValueChange={e => props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.name, e)}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.nameError]}
                                    onFocus={() => props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.nameError)}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <TextInput
                                    labelText="Cognome*"
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.surname]}
                                    onValueChange={e => props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.surname, e)}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.surnameError]}
                                    onFocus={() => props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.surnameError)}
                                />
                            </InputWrapper>
                            <InputWrapper hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Email*"
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.email]}
                                    onValueChange={e => props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.email, e)}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.emailError]}
                                    onFocus={() => props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.emailError)}
                                    validator={VALIDATORS_TYPE.noValidation}
                                    onBlurValidator={() => {
                                        if (!fieldValidator(props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.email], VALIDATORS_TYPE.email)) {
                                            props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.emailError, ERROR_TEXTS.validationError);
                                        }
                                    }}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <TextInput
                                    labelText="Conferma email*"
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation]}
                                    onValueChange={e => props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation, e)}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmationError]}
                                    onFocus={() => props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmationError)}
                                    validator={VALIDATORS_TYPE.noValidation}
                                />
                            </InputWrapper>
                            <InputWrapper hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Cellulare*"
                                    name="PhoneNumber "
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone]}
                                    onValueChange={e => {
                                        if (fieldValidator(e, VALIDATORS_TYPE.phone)) {
                                            props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone, fieldValidator(e, VALIDATORS_TYPE.phone))
                                        }
                                    }}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError]}
                                    onFocus={() => {
                                        if (props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone].length === 0) {
                                            props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone, "+39");
                                        }
                                        props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError)
                                    }}
                                    onBlurValidator={() => {
                                        if (!fieldValidator(
                                            props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone],
                                            VALIDATORS_TYPE.isPhoneValid
                                        )) {
                                            props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError, ERROR_TEXTS.validationError);
                                        }
                                    }}
                                    validator={VALIDATORS_TYPE.noValidation}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <TextInput
                                    labelText="Codice fiscale*"
                                    value={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode]}
                                    onValueChange={e => props.onChangeText(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode, e.toUpperCase() )}
                                    error={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError]}
                                    onFocus={() => props.resetError(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError)}
                                    /*HelperComponent={
                                        <div onClick={() => setIsPopupOpen(true)} style={{
                                            display:
                                                props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.name].length > 0 && props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.surname].length > 0 ? 'block' : 'none'
                                        }}>
                                            <div className="d-none d-md-block" >
                                                <TextInputHelperText>Non ricordo il codice fiscale</TextInputHelperText>
                                            </div>
                                            <div className="d-md-none d-lg-none d-xl-none">
                                                <TextInputHelperText>Non ricordo il c.f.</TextInputHelperText>
                                            </div>
                                        </div>
                                    }*/
                                    validator={VALIDATORS_TYPE.noValidation}
                                />
                            </InputWrapper>

                            <PrivacyBlock
                                onChange={accepted => props.onChangePrivacy(accepted)}
                                isAccepted={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.isPrivacyAccepted]}
                            />

                            <SubmitButton
                                mainColor={THEME_COLORS.blueViolet}
                                type="submit"
                                id="personalDataFormSubmit"
                                color={THEME_COLORS.white}
                                value="Invia"
                                disabled={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm]}
                                onClick={async e => {
                                    e.preventDefault();

                                    try {
                                        const hashedPhones = props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone]
                                        //let HashedPhonesMD5 = ''
                                        if (hashedPhones.length > 3 ){
                                            const HashedPhonesMD5 = Md5(hashedPhones).toString()
                                            window.tC.event.CallMeBackForm(this, { hashed_phone: HashedPhonesMD5 })
                                            window.tC.event.confirmStep(this, {stepId: 'funnel_step2', user_id : HashedPhonesMD5})
                                            console.log ('Userid Hashed from phone number, not read from cookie')
                                            console.log('tCEvent-> confirmStep funnel_step2')

                                        }
                                        else(
                                            console.log('phone not hashed', hashedPhones.length)
                                        )



                                        await props.validateAndSend();

                                        props.history.push('/indirizzo-fornitura')
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                                errorText={props.form[PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission]}
                            />
                        </FormContainer>
                        <AccordionContainer>
                            <Accordion />
                        </AccordionContainer>
                    </div>
                    <div className="col-xl-3">
                        <OfferBox {...props.offer} />
                    </div>
                </div>
            </div>
            <BottomSheet
                TriggerContent={
                    <BottomsheetTriggerContainer>
                        <div style={{ marginRight: '20px' }}>
                            <BottomsheetTriggerTitle>{props.offer.name}</BottomsheetTriggerTitle>
                            <BottomsheetTriggerSubTitle>VISUALIZZA I DETTAGLI</BottomsheetTriggerSubTitle>
                        </div>
                    </BottomsheetTriggerContainer>
                }
                HeaderContent={<BottomSheetHeaderText>CHIUDI I DETTAGLI</BottomSheetHeaderText>}
                backgroundColor="white"
                Content={<Offer {...props.offer}  isMobile={true}/>}
                maxExcludedScreenSize={MEDIA_QUERIES.desktop}
            />
        </React.Fragment>
    );
}